import "./style/style";
import React from "react";
import { getBuildId } from "./utils/utils";
import { createRoot } from "react-dom/client";
import { ReportGenerationPage } from "./components/pages/report-generation/ReportGenerationPage";

export default async function startEasasJsReports() {
  console.log("EASAS-JS reports bundle entry point...");
  console.log("Auto CD Build ID: " + getBuildId());

  const rootEl = document.getElementById("root");
  const reactRoot = createRoot(rootEl as HTMLElement);
  const app = <ReportGenerationPage />;

  reactRoot.render(app);

  if (module.hot) {
    console.log("Accepting hot reload...");
    module.hot.accept();
    // window.location.reload();
  }
}
